import { SVGProps } from 'react';
import { ReactComponent } from 'icons/cross.svg';

/**
 * @deprecated Move to storybook instead
 */
export const CrossIcon = (props: SVGProps<SVGSVGElement>) => {
  return <ReactComponent {...props} />;
};
